module.exports = __webpack_public_path__ + "img/bcg.a77599e8.png";